import $ from 'jquery';
import smoothscroll from 'smoothscroll-polyfill';
import {
  Dropdown,
  FilterTextInput,
  SearchInput,
  setupCheckboxes,
  setupCookieConsent,
  setupPagers,
} from './components';
import { setupAutoSubmitForms } from './form';
import { setupNav } from './nav';
import { setupHomePage } from './pages';
import { scrollElementToTop } from './utils';

(window as unknown as any).$ = $;

smoothscroll.polyfill();

setupNav();
setupDropdowns();
setupCheckboxes();
setupFilterInputs();
setupSearchInputs();
setupPages();
setupAutoSubmitForms();
setupPagers();
setupCookieConsent();
setupAnchorSmoothScroll();

function setupPages() {
  setupHomePage();
}

function setupDropdowns() {
  const dropdownElements = document.getElementsByClassName('dropdown');
  for (const dropdownElement of dropdownElements) {
    new Dropdown(dropdownElement);
  }
}

function setupFilterInputs() {
  $('input[data-filter-input]').each((_, element) => {
    new FilterTextInput(element);
  });
}

function setupSearchInputs() {
  $('[data-component="search-input"] input').each((_, element) => {
    new SearchInput(element, {});
  });
}

function setupAnchorSmoothScroll() {
  $('a[href^="#"]').on('click', function () {
    const targetId = $(this).attr('href')?.substring(1);
    if (!targetId) {
      return;
    }

    const element = document.getElementById(targetId);
    if (!element) {
      return;
    }

    scrollElementToTop(element);

    return false;
  });
}
